var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSignOutV216Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 12C1.875 12.2876 1.9863 12.5742 2.20605 12.7939L5.95605 16.5439C6.39405 16.9834 7.10595 16.9834 7.54395 16.5439C7.98345 16.1059 7.98345 15.394 7.54395 14.956L5.71582 13.125H16.5C17.121 13.125 17.625 12.621 17.625 12C17.625 11.379 17.121 10.875 16.5 10.875H5.71582L7.54395 9.04391C7.98345 8.60591 7.98345 7.89402 7.54395 7.45602C7.10595 7.01652 6.39405 7.01652 5.95605 7.45602L2.20605 11.206C1.9863 11.4258 1.875 11.7123 1.875 12Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.375 19.5C9.375 20.949 10.5495 22.125 12 22.125H19.5C20.196 22.125 20.8625 21.848 21.3545 21.3545C21.848 20.8625 22.125 20.196 22.125 19.5V4.5C22.125 3.804 21.848 3.13751 21.3545 2.64551C20.8625 2.15201 20.196 1.875 19.5 1.875H12C10.5495 1.875 9.375 3.051 9.375 4.5V6C9.375 6.621 9.879 7.125 10.5 7.125C11.121 7.125 11.625 6.621 11.625 6V4.5C11.625 4.293 11.793 4.125 12 4.125H19.5C19.599 4.125 19.6961 4.1629 19.7666 4.2334C19.8371 4.3039 19.875 4.401 19.875 4.5V19.5C19.875 19.599 19.8371 19.6961 19.7666 19.7666C19.6961 19.8371 19.599 19.875 19.5 19.875H12C11.793 19.875 11.625 19.707 11.625 19.5V18C11.625 17.379 11.121 16.875 10.5 16.875C9.879 16.875 9.375 17.379 9.375 18V19.5Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignOutV216Light);
export default __webpack_public_path__ + "static/media/ic_sign_out_v2_16_light.009db2757f4db7b1a505e50f012cfb8f.svg";
export { ForwardRef as ReactComponent };